import { ONE_DAY_DURATION } from '../../helpers/constants'

export const makeCardNames = (t) => ({
  totalEventSignups: t('building-analytics:card.names.totalEventSignups'),
  uniqueEventSignups: t('building-analytics:card.names.uniqueEventSignups'),
  newUsers: t('building-analytics:card.names.newUsers'),
  newServiceBookings: t('building-analytics:card.names.newServiceBookings'),
  totalServiceBookings: t('building-analytics:card.names.totalServiceBookings'),
})

export const types = {
  totalEventSignups: 'totalevents',
  uniqueEventSignups: 'uniquevents',
  newUsers: 'users',
  newServiceBookings: 'newservices',
  totalServiceBookings: 'totalservices',
}

export const colors = {
  newUsers: 'rgba(75, 85, 183, 0.2)',
  newServiceBookings: 'rgba(129, 50, 231, 0.2)',
  totalServiceBookings: 'rgba(46, 128, 251, 0.2)',
  totalEventSignups: 'rgba(82, 196, 26, 0.2)',
  uniqueEventSignups: 'rgba(26, 196, 165, 0.2)',
  housekeeping: '#F970B2',
  personalTraining: '#86BEFF',
  massage: '#9086FF',
  nutrition: '#8DD98B',
  mealDelivery: '#2DC77D',
  virtualTraining: '#FF8686',
  dogWalking: '#614ED6',
  petVisit: '#F5C464',
  dogGrooming: '#8BD997',
  smarthome: '#DA6A6A',
  tvMounting: '#9086FF',
  handyman: '#92CF6D',
  closetAudit: '#F970B2',
  catSitting: '#E3B65E',
  declutter: '#9086FF',
  furnitureAssembly: '#B065A0',
  nails: '#F970B2',
  hair: '#F970B2',
  skinTreatments: '#F970B2',
  packingEcoBox: '#9086FF',
  moving: '#9086FF',
}

const getPeriodValue = (daysAmount) => {
  let end = new Date()
  let start = new Date(end.getTime() - daysAmount * ONE_DAY_DURATION)
  return { start, end }
}

const getPeriod = (daysAmount, t) => ({
  days: daysAmount,
  value: getPeriodValue(daysAmount),
  title: t('building-analytics:periods.lastDays', { count: daysAmount }),
})

export const makePeriods = (t) => [
  getPeriod(7, t),
  getPeriod(30, t),
  getPeriod(60, t),
  getPeriod(90, t),
]

// Date-only default (no title), safe to use at module scope outside React
// (e.g. Redux reducer initial state) where a translation function isn't available.
export const DEFAULT_ANALYTICS_PERIOD_VALUE = getPeriodValue(30)
